import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/font/iconfont.css';

import './assets/main.css'

pdfjsLib.GlobalWorkerOptions.workerSrc = './pdflist/pdf/build/pdf.worker.js'

Vue.prototype.$PDFJS = pdfjsLib;

// let aiurl = "http://localhost:3000/api/ai/chat"; //开发地址
let aiurl = "https://nuxt3.23night.cn/api/ai/chat"; //配置子域名映射正式环境地址
Vue.prototype.aiurl = aiurl;

Vue.config.productionTip = false

Vue.use(ElementUI);

new Vue({
  render: h => h(App),
}).$mount('#app')
